/*------------------------------------------------
// File Name:PDM_Order.js
// File Description:PDM_Order API方法js接口
// Author:zxl
// Create Time:2022/12/16 15:02:54
//------------------------------------------------*/
import { axios } from '@/utils/request'

const api = {
   _order: "/PDM_Order"
}

export default api


//-------------------创建用户订单主表对象-------------------
export function CreatePDM_OrderEntity(parameter) {
    return axios({
        url: api._order + "/CreatePDM_OrderEntity",
        method: 'post',
        data: parameter
    })
}

//-------------------获取用户订单主表列表-------------------
export function GetPDM_OrderList(parameter) {
    return axios({
        url: api._order + "/GetPDM_OrderList",
        method: 'post',
        data: parameter
    })
}

//-------------------分页获取用户订单主表列表---------------
export function GetPDM_OrderListByPage(parameter) {
    return axios({
        url: api._order + "/GetPDM_OrderListByPage",
        method: 'post',
        data: parameter
    })
}

//-------------------获取用户订单主表对象---------------
export function GetPDM_OrderEntity(parameter) {
    return axios({
        url: api._order + "/GetPDM_OrderEntity",
        method: 'post',
        data: parameter
    })
}


//-------------------保存用户订单主表对象---------------
export function UpdatePDM_OrderEntity(parameter) {
    return axios({
        url: api._order+ "/UpdatePDM_OrderEntity",
        method: 'post',
        data: parameter
    })
}

//-------------------删掉用户订单主表对象---------------
export function DeletePDM_OrderEntity(parameter) {
    return axios({
        url: api._order + "/DeletePDM_OrderEntity",
        method: 'post',
        data: parameter
    })
}
